import axios from 'axios';

const uploadProblemImage = (file) => {
  const formData = new FormData();
  formData.append('image', file);
  return axios
    .post(`${process.env.REACT_APP_API_URL}/api/crop/uploadProblemImage`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((res) => res)
    .catch((err) => err);
};

export default uploadProblemImage;
